import MiniSearch from "minisearch";

const regionSearch = new MiniSearch({
  fields: ["name"],
  storeFields: ["name", "2018", "2023", "id"],
  searchOptions: {
    fuzzy: 0.2
  }
});

export default regionSearch;
